import Glide from "@glidejs/glide";
import ScrollReveal from "scrollreveal";
import { CountUp } from "countup.js";
import lozad from 'lozad';
import {
    Header,
    Accordion,
    AccordionProduct,
    Visible,
    MobileMenu,
    MobileAccordion,
    ShoppingCart
} from "./ui";
import { addToCart } from "./woocommerce";

const splashScreen = document.querySelector('#splash-screen');
const body = document.querySelector('body');
const site = document.querySelector('#site');
let viewSplashScreen = (sessionStorage.getItem('splashscreen')) ? false : true;
let timeout = (sessionStorage.getItem('splashscreen')) ? 0 : 3000;

window.addEventListener('DOMContentLoaded', () => {

    if (viewSplashScreen) {
        splashScreen.classList.add('visible');
        body.classList.add('no-scroll');
    }

    ScrollReveal({
        duration: 1000,
        distance: '50px',
        viewFactor: 0.0
    });

    document.addEventListener('click', event => {
        const origin = window.location.origin;

        if (event.target.tagName == 'A' && event.target.href.includes(origin)) {

            if (!event.target.href.includes('#')) {
                event.preventDefault();

                if (!event.target.classList.contains('ajax_add_to_cart') && !event.target.dataset.open && !event.target.classList.contains('remove') && !event.target.classList.contains('woocommerce-remove-coupon')) {
                    site.classList.remove('done');

                    setTimeout(() => {
                        window.location.href = event.target.href;
                    }, 350);
                }

            } else {
                const menu = document.querySelector('.mobile-menu');
                const button = document.querySelector('.mobile-menu-button');

                body.classList.remove('no-scroll');
                button.classList.remove('active');
                menu.classList.remove('open');
            }

        }
    })

    if (!localStorage.getItem('cookies')) {
        const cookieNotification = document.querySelector('.cookies-notification');
        const closeCookieNotification = document.querySelector('.cookies-notification .close');

        cookieNotification.style.display = 'block';

        closeCookieNotification.onclick = () => {
            localStorage.setItem('cookies', 'true');
            cookieNotification.style.display = 'none';
        }
    }

    //ShopAccordion();
    ShopPanels();
    addToCart();
})

window.onload = function () {
    const observer = lozad('.lozad', {
        loaded: el => el.classList.add('loaded')
    });
    observer.observe();

    if (viewSplashScreen) {
        setTimeout(() => {
            body.classList.remove('no-scroll');
            splashScreen.classList.remove('visible');
        }, 1000);
    }

    setTimeout(() => {
        splashScreen.classList.add('hide');
        site.classList.add('done');

        if (body.classList.contains('home')) {
            ScrollReveal().reveal('.hero-full .content', { distance: '0', delay: 350 });
            ScrollReveal().reveal('.highlighted-products .title', { delay: 350 });
            ScrollReveal().reveal('.highlighted-products .subtitle', { delay: 350 });
            ScrollReveal().reveal('ul.products li', { interval: 150, delay: 500 });
            ScrollReveal().reveal('.shop-link-wrapper', { delay: 300 });
            ScrollReveal().reveal('.one-for-one');
            ScrollReveal().reveal('.ors-block', { delay: 300 });
            ScrollReveal().reveal('.link-blocks .wp-block-column', { interval: 300 });
            ScrollReveal().reveal('.wp-block-quote');
            ScrollReveal().reveal('#slide-bottles');

            //Count();
        }

        if (body.classList.contains('page-template-sub-page')) {
            ScrollReveal().reveal('.hero-side', { origin: 'left' });
            ScrollReveal().reveal('.story-quote');
            ScrollReveal().reveal('.intro');
            ScrollReveal().reveal('.about-norr');
            ScrollReveal().reveal('.about-drink');
            ScrollReveal().reveal('.resellers-title');
            ScrollReveal().reveal('.resellers li', { delay: 300, interval: 300 });

            ScrollReveal().reveal('.ors-why');
            ScrollReveal().reveal('.ors-how-title');
            ScrollReveal().reveal('.ors-how');
            ScrollReveal().reveal('.ors-one-ten .illustrations');
            ScrollReveal().reveal('.ors-one-ten p');
            ScrollReveal().reveal('.ors-quote');
            ScrollReveal().reveal('.ors-packages');
            ScrollReveal().reveal('.ors-partners .wp-block-column', { interval: 300 });

            if (document.querySelector('#ors-count')) {
                Count();
            }

        } else {
            ScrollReveal().reveal('.shop-title');
            ScrollReveal().reveal('.shop-title+p');
            ScrollReveal().reveal('.shop-type');
            ScrollReveal().reveal('.shop-list-section #google-map');
            ScrollReveal().reveal('.shop-list-section.physical .shop', { interval: 300 });
            ScrollReveal().reveal('body.aterforsaljare .content .resellers a', { interval: 300 });
            ScrollReveal().reveal('body.aterforsaljare .content .others', { delay: 300 });
            ScrollReveal().reveal('body.resellers .content .resellers a', { interval: 300 });
            ScrollReveal().reveal('body.resellers .content .others', { delay: 300 });
            ScrollReveal().reveal('body.for-foretag .wp-block-column:first-of-type');
            ScrollReveal().reveal('body.for-foretag .wp-block-column:last-of-type', { interval: 300, delay: 300 });
            ScrollReveal().reveal('body.for-companies .wp-block-column:first-of-type');
            ScrollReveal().reveal('body.for-companies .wp-block-column:last-of-type', { interval: 300, delay: 300 });
        }

        if (body.classList.contains('woocommerce-shop')) {
            ScrollReveal().reveal('.page-title');
            ScrollReveal().reveal('.shop-preferences', { delay: 150 });
            ScrollReveal().reveal('ul.products li', { interval: 150, delay: 300 });
        }

        if (body.classList.contains('woocommerce-checkout')) {
            ScrollReveal().reveal('.checkout-title');
            ScrollReveal().reveal('.checkout_coupon', { delay: 150 });
            ScrollReveal().reveal('#kco-wrapper', { delay: 300 });
        }

        if (body.classList.contains('single-product')) {
            ScrollReveal().reveal('.link-back');
            ScrollReveal().reveal('.product-images');
            ScrollReveal().reveal('.product .summary', { delay: 300 });
        }

        sessionStorage.setItem('splashscreen', 'true');
    }, timeout);

    if (body.classList.contains('home')) {
        if (document.querySelector('#slideshow')) {
            new Glide('#slideshow', {
                type: 'slider',
            }).mount();
        }

        let glide = new Glide('#slide-bottles', {
            type: 'carousel',
            perView: 5,
            startAt: 2,
            focusAt: 'center',
            gap: 0,
            dragThreshold: false,
            breakpoints: {
                1700: {
                    perView: 5,
                    dragThreshold: false
                },
                900: {
                    perView: 3,
                    dragThreshold: 120
                }
            }
        }).mount();

        slider(glide);
        Accordion();
    }

    if (body.classList.contains('for-foretag') || body.classList.contains('for-companies')) {
        if (document.querySelector('.glide')) {
            let glide = new Glide('.glide', {
                type: 'slider',
                bound: true,
                keyboard: false,
                swipeThreshold: false,
                dragThreshold: false,
                perView: 2,
                gap: 20,
                peek: { before: 0, after: 100 },
                breakpoints: {
                    600: {
                        swipeThreshold: true,
                        dragThreshold: true,
                        perView: 1
                    }
                }
            }).mount();

            glide.on(['mount.after', 'run'], () => {
                Controller();
            })

            const Controller = () => {
                const prev = document.querySelector('.prev');
                const next = document.querySelector('.next');

                if (glide.index === 0) {
                    prev.disabled = true;
                } else {
                    prev.disabled = false;
                }

                if (window.outerWidth > 350) {
                    if (glide.index === document.querySelectorAll('.glide__slide').length / 2) {
                        next.disabled = true;
                    } else {
                        next.disabled = false;
                    }

                } else {
                    if (glide.index === document.querySelectorAll('.glide__slide').length) {
                        next.disabled = true;
                    } else {
                        next.disabled = false;
                    }
                }
            }
        }
    }

    if (body.classList.contains('single-product')) {
        AccordionProduct();
    }

    Header();
    MobileAccordion();
    MobileMenu();
    ShoppingCart();

    // Reload shipping cart button listener.
    jQuery('body').on('added_to_cart', () => ShoppingCart());
}

const Count = () => {
    document.addEventListener('scroll', () => {
        const ors = document.querySelector('.ors-block');

        if (Visible('.ors-block')) {

            if (!ors.classList.contains('visible')) {
                ors.classList.add('visible');

                let amount = parseInt(document.querySelector('#ors-count').dataset.amount);

                new CountUp('ors-count', amount, {
                    startVal: 300000,
                    decimalPlaces: 0,
                    useGrouping: false,
                    duration: 4
                }).start();
            }
        }
    })
}

const slider = (glide) => {
    const slides = document.querySelectorAll('.glide__slide');
    const parent = document.querySelector('#slide-bottles');
    const prev = document.querySelector('.prev');
    const next = document.querySelector('.next');
    const prevButton = document.querySelector('.prev button');
    const nextButton = document.querySelector('.next button');

    if (window.outerWidth > 900) {
        prev.classList.add('disabled');
        next.classList.add('disabled');
        prevButton.disabled = true;
        nextButton.disabled = true;
    }

    glide.on('run.after', () => {
        prev.classList.remove('disabled');
        next.classList.remove('disabled');
        prevButton.disabled = false;
        nextButton.disabled = false;

        if (window.outerWidth > 900) {
            if (glide.index === 2) {
                prev.classList.add('disabled');
                next.classList.add('disabled');
                prevButton.disabled = true;
                nextButton.disabled = true;
            }

            if (glide.index === 3) {
                next.classList.add('disabled');
                prev.classList.add('disabled');
                nextButton.disabled = true;
                prevButton.disabled = true;
            }
        }
    })

    slides.forEach(slide => {
        slide.addEventListener('click', event => {
            if (slide.classList.contains('glide__slide--active')) {
                if (event.target.tagName == 'IMG') {

                    slide.classList.toggle('open');
                    parent.classList.toggle('open');

                    slides.forEach(slide => {
                        slide.classList.toggle('offset');
                    })

                    if (slide.classList.contains('open')) {
                        glide.disable()
                    } else {
                        glide.enable()
                    }
                }

                if (event.target.classList.contains('close')) {
                    slide.classList.remove('open');
                    parent.classList.remove('open');
                    slides.forEach(slide => {
                        slide.classList.remove('offset');
                    })

                    if (window.outerWidth > 900) {
                        setTimeout(() => {
                            glide.enable();

                            if (glide.index < 2) {
                                glide.go('=2');

                            } else if (glide.index > 2) {
                                glide.go('=3');
                            }
                        }, 500);
                    }
                }

            }

            if (slide.classList.contains('glide__slide') && !slide.classList.contains('glide__slide--active')) {
                slides.forEach(slide => {
                    slide.classList.remove('offset');
                    slide.classList.remove('open');
                    parent.classList.remove('open');
                    glide.enable();
                })

                if (event.target.tagName == 'IMG') {
                    let selected = document.querySelector(`.glide__slide:not( .glide__slide--clone ) [data-index="${event.target.dataset.index}"]`).parentElement.parentElement;

                    glide.go('=' + event.target.dataset.index);

                    setTimeout(() => {
                        selected.classList.toggle('open');
                        parent.classList.toggle('open');

                        slides.forEach(slide => {
                            slide.classList.toggle('offset');
                        })

                        if (selected.classList.contains('open')) {
                            glide.disable()
                        } else {
                            glide.enable()
                        }
                    }, 500);
                }
            }
        })
    });
}

// Handle panels for shop page.
const ShopPanels = () => {
    if (document.querySelector('.shop-type')) {
        const physical = document.querySelector('.physical');
        const online = document.querySelector('.online');
        const physicalPanel = document.querySelector('.shop-list-section.physical');
        const onlinePanel = document.querySelector('.shop-list-section.online');

        physical.onclick = () => {
            online.classList.remove('active');
            physical.classList.add('active');

            panels('physical');
        }

        online.onclick = () => {
            physical.classList.remove('active');
            online.classList.add('active');

            panels('online');
        }

        const panels = panel => {
            if (panel == 'online') {

                physicalPanel.classList.remove('visible');

                setTimeout(() => {
                    physicalPanel.classList.add('disabled');
                    onlinePanel.classList.remove('disabled');

                    setTimeout(() => {
                        onlinePanel.classList.add('visible');
                    }, 100);
                }, 300);

            } else if (panel == 'physical') {

                onlinePanel.classList.remove('visible');

                setTimeout(() => {
                    onlinePanel.classList.add('disabled');
                    physicalPanel.classList.remove('disabled');

                    setTimeout(() => {
                        physicalPanel.classList.add('visible');
                    }, 100);
                }, 300);
            }
        }
    }
}